import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface SectorEntry {
  slug: string;
  name: string;
  description: string;
}

export interface SectorGridProps {
  title?: string;
  sectors: SectorEntry[];
}

export function SectorGrid({ title, sectors }: SectorGridProps) {
  return (
    <section className="bg-stone-50 py-16">
      <Container>
        {title ? <h2 className="mb-8 text-3xl font-bold tracking-tightish">{title}</h2> : null}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {sectors.map((sector) => (
            <a
              key={sector.slug}
              href={`/secteurs/${sector.slug}`}
              className="group rounded-xl border border-stone-200 bg-white p-6 shadow-soft transition hover:border-brand-300 hover:shadow-elevated"
            >
              <p className="font-display text-lg font-semibold text-stone-900 group-hover:text-brand-700">
                {sector.name}
              </p>
              <p className="mt-2 text-sm text-stone-600">{sector.description}</p>
              <p className="mt-3 text-xs font-semibold uppercase tracking-wider text-brand-700">
                Découvrir →
              </p>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export const SectorGridConfig: ComponentConfig<SectorGridProps> = {
  fields: {
    title: { type: 'text' },
    sectors: {
      type: 'array',
      arrayFields: {
        slug: { type: 'text' },
        name: { type: 'text' },
        description: { type: 'textarea' },
      },
      defaultItemProps: { slug: '', name: '', description: '' },
    },
  },
  defaultProps: {
    title: '6 secteurs accompagnés',
    sectors: [
      { slug: 'industrie', name: 'Industrie', description: 'Process, utilités, isolation.' },
      { slug: 'tertiaire', name: 'Tertiaire', description: 'Bureaux, commerces, hôtellerie.' },
      { slug: 'agriculture', name: 'Agriculture', description: 'Élevage, serres, cultures.' },
      { slug: 'copropriete', name: 'Copropriété', description: "Audits, isolation par l’extérieur (ITE), chaufferies." },
      { slug: 'association', name: 'Association', description: 'Bâtiments, équipements.' },
      { slug: 'particuliers', name: 'Particuliers', description: 'Maison, appartement.' },
    ],
  },
  render: SectorGrid,
};
